import type { Config } from 'msp-integrations'

export const getStyles = (config: Config, darkMode = false) => ({
  base: `relative w-full group text-14 tracking-0 mt-3`,
  default: {
    div: `
        text-machine2-75
        stroke-machine2-75
        ${
          !darkMode
            ? config.theme.mspComponents?.input?.default?.div
            : config.theme.mspComponents?.input?.default?.div_Dark ?? ''
        }
        `,
    label: {
      base: `
            relative
            z-[1]
            whitespace-nowrap
            bg-transparent
            transition-colors
            ${config.theme.font.regular}
            ${
              !darkMode
                ? config.theme.mspComponents?.input?.default?.label
                : config.theme.mspComponents?.input?.default?.label_Dark ?? ''
            }
            `,
      disabled: `
            bg-transparent
            ${
              darkMode
                ? config.theme.mspComponents?.input?.default?.labelDarkDisabled
                : config.theme.mspComponents?.input?.default?.labelDisabled
            }
            `
    },
    input: `
        h-12
        px-[24px]
        rounded
        border
        border-machine2-75
        focus:outline-none
        focus:ring-2
        transition
        disabled:border-machine2-75
        disabled:bg-machine2-25
        disabled:transform-none
        disabled:transition-none
        disabled:group-hover:border-machine2-75
        ${config.theme.font.medium}
        ${
          !darkMode
            ? config.theme.mspComponents?.input?.default?.input
            : config.theme.mspComponents?.input?.default?.input_Dark ?? ''
        }
        `,
    passwordIcon: `
        h-12
        right-[16px]
        transition-colors
        ${
          darkMode
            ? config.theme.mspComponents?.input?.default?.passwordIconDark
            : config.theme.mspComponents?.input?.default?.passwordIcon
        }
        `,
    helperText: `
        text-12
        ${config.theme.font.regular}
        `
  },
  underline: {
    div: '',
    label: { base: '', disabled: '' },
    input: `
        h-7
        px-0
        font-medium
        rounded-none
        border-b-[1px]
        bg-transparent
        focus:ring-0
        focus:outline-none
        disabled:placeholder:text-machine2-75
        disabled:border-machine2-75
        ${config.theme.font.medium}
        ${
          !darkMode
            ? config.theme.mspComponents?.input?.underline?.input
            : config.theme.mspComponents?.input?.underline?.input_Dark ?? ''
        }
        `,
    passwordIcon: `
        h-7
        right-[6px]
        ${
          darkMode
            ? config.theme.mspComponents?.input?.underline?.passwordIconDark
            : config.theme.mspComponents?.input?.underline?.passwordIcon
        }
        `,
    helperText: `
        text-12
        ${config.theme.font.regular}
        `
  }
})
